module.exports = __webpack_public_path__ + "img/jonh-mcqueen.a328df11.png";